import { render, staticRenderFns } from "./MaliangElementMenuChild.vue?vue&type=template&id=c5ba706c&scoped=true&"
import script from "./MaliangElementMenuChild.vue?vue&type=script&lang=js&"
export * from "./MaliangElementMenuChild.vue?vue&type=script&lang=js&"
import style0 from "./MaliangElementMenuChild.vue?vue&type=style&index=0&id=c5ba706c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5ba706c",
  null
  
)

export default component.exports